// The authentication states related to user login
export const AUTHENTICATION_STATES = {
	UNINITIALIZED: 'uninitialized',
	PENDING: 'pending',
	AUTHENTICATED: 'authenticated',
	FAILED: 'failed',
};
